
import Component from "vue-class-component"
import Page from "@/report/pages/Page.vue"
import AbstractPage from "@/report/pages/AbstractPage.vue"
import SuperScoreStarComponentWidget from "@/components/dashboard/SuperScoreStarComponentWidget.vue"
import {SuperScoreArea} from "@/superscore/SuperScoreArea"
import SankeyDiagram from "@/ui/chart/SankeyDiagram.vue"

@Component({
  name: "SuperScorePage",
  components: {
    Page,
    SuperScoreStarComponentWidget,
    SankeyDiagram,
  },
})
export default class SuperScorePage extends AbstractPage {
  SuperScoreArea = SuperScoreArea
}
